import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Text } from 'roo-ui/components';
import formatNumber from 'lib/formatters/formatNumber';
import { MIN_POINTS_AMOUNT } from 'config';
import usePointsRedemptionAvailable from 'pages/Checkout/CustomerDetails/Steps/PaymentOptions/hooks/usePointsRedemptionAvailable';
import { getPointsAmount } from 'store/checkout/checkoutSelectors';

const MinimumPointsMessages = () => {
  const pointsAmount = useSelector(getPointsAmount);
  const { isBalanceLessThanMinPoints, isPayableLessThanMinPoints } = usePointsRedemptionAvailable();

  return (
    <Fragment>
      {isBalanceLessThanMinPoints ? (
        <Text fontSize={['xs', 'base']} mr={[0, 4]} data-testid="insufficient-points-balance-message">
          Minimum {formatNumber({ number: MIN_POINTS_AMOUNT })} Qantas Points required.
        </Text>
      ) : (
        ''
      )}
      {pointsAmount.isZero() && !isBalanceLessThanMinPoints && isPayableLessThanMinPoints ? (
        <Text fontSize={['xs', 'base']} mr={[0, 4]} data-testid="insufficient-booking-points-amount-message">
          Booking minimum of {formatNumber({ number: MIN_POINTS_AMOUNT })} Qantas Points required.
        </Text>
      ) : (
        ''
      )}
    </Fragment>
  );
};

export default MinimumPointsMessages;
